import { Slot, Stack } from "expo-router";
import { ActivityIndicator } from "react-native";
import { View } from "@src/components";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { SupportAccessRestricted } from "@src/components/web/SupportAccessRestricted.web";
import { useSupportUserStatus } from "@src/features/tenants";

/**
 * Gates the whole Patriot tools subtree on the support role, so a deep link to
 * any page in it is covered by the same check.
 *
 * In the layout rather than each screen so a denied user never mounts a page's
 * data hooks. The API refuses non-support callers regardless.
 */
export default function PatriotToolsWebLayout() {
  const supportStatus = useSupportUserStatus();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        {supportStatus === "granted" ?
          <Slot />
        : supportStatus === "denied" ?
          <SupportAccessRestricted />
          // Roles not yet known. Waiting rather than denying, so a cold deep
          // link does not show the restricted notice to a support user.
        : <View flex={1} alignItems="center" justifyContent="center">
            <ActivityIndicator />
          </View>
        }
      </WebLayout>
    </>
  );
}
